import Skins from './skins';
export default Skins;